import type Maybe from 'graphql/tsutils/Maybe';

type CourseMaterial = {
  totalDuration?: Maybe<string>;
};
function getCourseAdjustedLearningHoursExperimentData<T extends CourseMaterial>(
  material: Maybe<T>,
  learningHoursOverride: number | null
): Maybe<T> {
  if (!material || !learningHoursOverride) return material;

  return {
    ...material,
    totalDuration: `PT${Math.max(Math.round(learningHoursOverride), 1)}H`,
  };
}

type SpecializationData = {
  id: string;
  totalLearningHours?: Maybe<number>;
  learningHoursPerWeek?: Maybe<number>;
};
function getS12nAdjustedLearningHoursExperimentData<T extends SpecializationData>(
  data: Maybe<T>,
  totalLearningHours: number | null
): Maybe<T> {
  if (!data || !totalLearningHours) return data;

  return {
    ...data,
    totalLearningMonths: totalLearningHours / 40,
    learningHoursPerWeek: 10,
  };
}

export { getCourseAdjustedLearningHoursExperimentData, getS12nAdjustedLearningHoursExperimentData };
